import styled from 'styled-components';
import { Modal, Form, Input, Button } from 'antd';

interface LoginFormData {
  phone: string;
  code: string;
  countryCode: string;
}

// 模态框容器
export const StyledModal = styled(Modal)`
  .ant-modal-content {
    width: 508px !important;
    flex-shrink: 0;
    border-radius: 12px !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    background: #1a1a1a !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .ant-modal-body {
    padding: 0 !important;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }

  .ant-modal-close {
    display: none !important;
  }

  .ant-modal-header {
    display: none !important;
  }

  .ant-modal-footer {
    display: none !important;
  }

  /* 覆盖模态框内所有链接的默认样式 */
  a {
    color: #dc5d33 !important;
    text-decoration: none !important;

    &:hover {
      color: #dc5d33 !important;
      text-decoration: underline !important;
    }

    &:visited {
      color: #dc5d33 !important;
    }

    &:active {
      color: #dc5d33 !important;
    }

    &:focus {
      color: #dc5d33 !important;
      outline: none !important;
    }

    &:link {
      color: #dc5d33 !important;
    }
  }
`;

// 模态框头部 - 参考PaymentModal结构
export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

// 模态框标题
export const ModalTitle = styled.h2`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
`;

// 关闭按钮 - 按照指定样式，包含标准hover效果
export const CloseButton = styled.button`
  display: flex;
  width: 28px;
  height: 28px;
  padding: 5px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 14px;
  background: #2f2f2f;
  border: none;
  cursor: pointer;
  justify-content: center;
  transition: background 0.2s ease;

  img {
    width: 17.971px;
    height: 17.971px;
    flex-shrink: 0;
    opacity: 0.4;
    transition: opacity 0.2s ease;
  }

  &:hover {
    background: #6a6a6a;
  }

  &:hover img {
    opacity: 1;
  }
`;

// 登录表单
export const LoginForm = styled(Form<LoginFormData>)`
  width: 100% !important;
  flex: 1;
  display: flex;
  flex-direction: column;

  .ant-form-item {
    margin-bottom: 20px !important;
  }

  .ant-form-item-label > label {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 14px !important;
  }

  .ant-form-item-explain-error {
    color: #ff4d4f !important;
    font-size: 12px !important;
    margin-top: 4px !important;
  }

  /* 确保最后一个表单项没有额外的margin */
  .ant-form-item:last-child {
    margin-bottom: 0 !important;
  }
`;

// 手机号输入框容器 - 参考登录页面样式
export const PhoneInputContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  border: 1px solid #777;
  border-radius: 8px;
  background-color: #121212;
  transition: border-color 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: #fff;
  }

  &:focus-within {
    border-color: #fff;
  }
`;

// 手机号前缀 - 参考登录页面样式
export const PhonePrefix = styled.div`
  padding: 0 18px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 100%;
`;

// 手机号分隔线 - 参考登录页面样式
export const PhoneDivider = styled.div`
  display: block;
  width: 1px;
  height: 14.5px;
  background-color: #fff;
  opacity: 0.3;
  flex-shrink: 0;
`;

// 手机号输入框 - 参考登录页面样式
export const PhoneInput = styled(Input)`
  flex: 1 !important;
  background-color: transparent !important;
  border: none !important;
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 16px !important;
  height: 48px !important;
  padding: 0 18px !important;
  outline: none !important;
  box-shadow: none !important;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45) !important;
  }

  &:hover {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  &:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  &.ant-input {
    background-color: transparent !important;
    border: none !important;
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 16px !important;
    outline: none !important;
    box-shadow: none !important;

    &::placeholder {
      color: rgba(255, 255, 255, 0.45) !important;
    }

    &:hover {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    &:focus {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }
  }
`;

// 验证码容器 - 参考登录页面样式
export const VerificationContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  border: 1px solid #777;
  border-radius: 8px;
  background-color: #121212;
  padding-right: 10px;
  transition: border-color 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: #fff;
  }

  &:focus-within {
    border-color: #fff;
  }
`;

// 验证码输入框 - 参考登录页面样式
export const VerificationInput = styled(Input)`
  flex: 1 !important;
  background-color: transparent !important;
  border: none !important;
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 16px !important;
  height: 48px !important;
  padding: 0 18px !important;
  outline: none !important;
  box-shadow: none !important;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45) !important;
  }

  &:hover {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  &:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  &.ant-input {
    background-color: transparent !important;
    border: none !important;
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 16px !important;
    outline: none !important;
    box-shadow: none !important;

    &::placeholder {
      color: rgba(255, 255, 255, 0.45) !important;
    }

    &:hover {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    &:focus {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }
  }
`;

// 发送验证码按钮 - 参考登录页面样式
export const SendCodeButton = styled(Button)`
  height: 40px !important;
  padding: 0 16px !important;
  border-radius: 7px !important;
  border: none !important;
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 21px !important;
  white-space: nowrap;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: background-color 0.2s ease;
  outline: none !important;
  box-shadow: none !important;

  &.ant-btn {
    height: 40px !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Enabled state */
  &:not(:disabled),
  &.ant-btn:not(:disabled) {
    background: #ff6d49 !important;
    color: #fff !important;
    cursor: pointer;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Hover state when enabled */
  &:not(:disabled):hover,
  &.ant-btn:not(:disabled):hover {
    background: #ff886b !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Disabled state */
  &:disabled,
  &.ant-btn:disabled {
    background: #2b2b2b !important;
    color: #979797 !important;
    cursor: not-allowed;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Countdown state (also disabled, but with different text color) */
  &.countdown:disabled,
  &.countdown.ant-btn:disabled {
    color: #fff !important;
    background: #2b2b2b !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }
`;

// 协议说明文字 - 与验证码输入框对齐
export const AgreementText = styled.div`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  margin-bottom: 20px;
  line-height: 1.5;
  width: 100%;
  text-align: left;
  justify-content: flex-start;
`;

// 协议链接
export const AgreementLink = styled.a`
  color: #dc5d33 !important;
  text-decoration: none !important;

  &:hover {
    color: #dc5d33 !important;
    text-decoration: underline !important;
  }

  &:visited {
    color: #dc5d33 !important;
  }

  &:active {
    color: #dc5d33 !important;
  }

  &:focus {
    color: #dc5d33 !important;
    outline: none !important;
  }

  &:link {
    color: #dc5d33 !important;
  }

  /* 覆盖Antd的默认链接样式 */
  &.ant-typography {
    color: #dc5d33 !important;
  }

  /* 覆盖所有可能的Antd样式 */
  && {
    color: #dc5d33 !important;
    text-decoration: none !important;
  }

  &&:hover {
    color: #dc5d33 !important;
    text-decoration: underline !important;
  }

  &&:visited {
    color: #dc5d33 !important;
  }

  &&:active {
    color: #dc5d33 !important;
  }

  &&:focus {
    color: #dc5d33 !important;
  }

  &&:link {
    color: #dc5d33 !important;
  }
`;

// 提交按钮 - 按照图片样式
export const SubmitButton = styled(Button)`
  width: 150px !important;
  height: 40px !important;
  flex-shrink: 0;
  border: none !important;
  border-radius: 10px !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  outline: none !important;
  box-shadow: none !important;
  margin: 0 auto !important;

  /* 覆盖Antd的默认样式 */
  &.ant-btn {
    width: 150px !important;
    height: 40px !important;
    border: none !important;
    border-radius: 10px !important;
    padding: 0 !important;
    line-height: 40px !important;
    display: inline-flex !important;
    margin: 0 auto !important;
  }

  /* 覆盖所有可能的边框状态 */
  &:hover,
  &:focus,
  &:active,
  &.ant-btn:hover,
  &.ant-btn:focus,
  &.ant-btn:active {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* 默认状态 - 灰色背景 */
  &:disabled,
  &.ant-btn:disabled {
    background: #666 !important;
    color: rgba(255, 255, 255, 0.6) !important;
    border: none !important;
    outline: none !important;
    transform: none;
    box-shadow: none !important;
    cursor: not-allowed;

    &::before {
      display: none;
    }
  }

  /* 启用状态 - 渐变背景 */
  &:not(:disabled),
  &.ant-btn:not(:disabled) {
    background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%) !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* hover效果 */
  &:hover:not(:disabled),
  &.ant-btn:hover:not(:disabled) {
    background: linear-gradient(123deg, #ffb952 19.66%, #ff7a56 67.36%) !important;
    border: none !important;
    box-shadow: none !important;
  }

  &:active:not(:disabled),
  &.ant-btn:active:not(:disabled) {
    transform: scale(0.98);
    border: none !important;
    box-shadow: none !important;
  }

  /* 确保内容在伪元素之上 */
  & > * {
    position: relative;
    z-index: 1;
  }

  /* 覆盖loading状态 */
  &.ant-btn-loading {
    background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%) !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

// 箭头图标
export const ArrowIcon = styled.span`
  width: 12px;
  height: 11px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 12px;
    height: 11px;
    fill: white;
  }
`;
